import { Injectable } from '@angular/core';
import {
  Actions,
  Effect,
  ofType
} from '@ngrx/effects';
import {
  delay,
  map
} from 'rxjs/operators';
import {
  IsLoading,
  IsLoaded
} from './loading.actions';
import {
  Login,
  AuthActionTypes
} from '../authentication/actions/auth.actions';
import { Store } from '@ngrx/store';
import { isAppReady } from '../life-cycle/life-cycle.selectors';

@Injectable()
export class LoadingEffects {

  @Effect()
  public isAppReady$ = this.store$.select(isAppReady).pipe(
    map(isReady => isReady ? new IsLoaded('LoadingEffects::isAppReady$') : new IsLoading('LoadingEffects::isAppReady$'))
  );

  @Effect({ resubscribeOnError: true })
  public loginStart$ = this.actions$.pipe(
    ofType<Login>(AuthActionTypes.Login),
    map(() => new IsLoading('LoadingEffects::loginStart$')),
  );

  @Effect({ resubscribeOnError: true })
  public loginSuccessful$ = this.actions$.pipe(
    ofType(AuthActionTypes.LoginSuccessful),
    delay(500),
    map(() => new IsLoaded('LoadingEffects::loginEnd$')),
  );

  @Effect({ resubscribeOnError: true })
  public loginFailed$ = this.actions$.pipe(
    ofType(AuthActionTypes.LoginFailed),
    map(() => new IsLoaded('LoadingEffects::loginEnd$')),
  );

  constructor(
    private actions$: Actions,
    private store$: Store<any>,
  ) {}

}
